import Tab from "components/Tab";
import { Steps, Step } from 'components/Docs/Steps';
import Beta from "../../../../contents/docs/logs/_snippets/beta.mdx";
import * as React from 'react';
export default {
  Tab,
  Steps,
  Step,
  Beta,
  React
};